import { ReactNode } from "react";

import { Breadcrumb, type BreadcrumbItem } from "../Breadcrumb/Breadcrumb";
import styles from "./PageHeader.module.css";

interface Props {
  breadcrumb?: BreadcrumbItem[];
  title: ReactNode;
  actions?: ReactNode;
  tabs?: ReactNode;
}

/**
 * Sticky frosted page header — breadcrumb + h1 + actions + optional tabs row.
 * Mirrors shell-v2.html L173–L189: position sticky, --bg-header backdrop blur,
 * border-bottom. The host page is expected to scroll inside the main column
 * so the header pins to the top of the visible viewport.
 */
export function PageHeader({ breadcrumb, title, actions, tabs }: Props) {
  return (
    <header className={styles.pageHeader}>
      <div className={styles.row}>
        <div className={styles.left}>
          {breadcrumb && <Breadcrumb items={breadcrumb} />}
          <h1 className={styles.title}>{title}</h1>
        </div>
        {actions && <div className={styles.actions}>{actions}</div>}
      </div>
      {tabs && <div className={styles.tabsRow}>{tabs}</div>}
    </header>
  );
}
